<template>
<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl py-0>
			<app-card
				heading="Logs"
				customClasses="mb-30">
				<v-data-table
					v-model="selected"
					:headers="headers"
					:items="logItems"
					item-key="name"
					select-all
					class="elevation-1"
				>
					<template slot="items" slot-scope="props">
					<td>
						<v-checkbox
						v-model="props.selected"
						primary
						hide-details
						></v-checkbox>
					</td>
					<td>{{ props.item.name }}</td>
					<td class="text-xs-right">{{ props.item.calories }}</td>
					<td class="text-xs-right">{{ props.item.fat }}</td>
					<td class="text-xs-right">{{ props.item.carbs }}</td>
				
					</template>
				</v-data-table>
			</app-card>
		</v-container>
		<!-- <v-snackbar
			v-model="isReportingCacheRecreated"
			:right="true"
			:timeout="6000"
			:top="true">
				Reporting Cache successfully recreated with {{ reportingCacheItems }} items.
			<v-btn
				flat
				@click="isReportingCacheRecreated = false">
				Close
			</v-btn>
    	</v-snackbar>
		<v-snackbar
			v-model="isOhRecreated"
			:right="true"
			:timeout="6000"
			:top="true">
				Order Cache successfully recreated with {{ ohCacheItems }} items.
			<v-btn
				flat
				@click="isOhRecreated = false">
				Close
			</v-btn>
    	</v-snackbar> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
		    headers: [
				{
					text: 'Date',
					align: 'left',
					sortable: true,
					value: 'name'
				},
				{
					text: 'level',
					value: 'calories',
					sortable: false
				},
				{ text: 'Module', value: 'fat' },
				{ text: 'Message', value: 'carbs' }
			],
			logItems: [],
			selected: []
        }
    },
    computed: {
        ...mapGetters([
            'users'
        ])
    },
    methods: {
		recreateReportingCache () {
			this.$confirm(`Do you really want to recreate the Reporting cache?`, {
                color: 'warning',
                icon: 'warning',
                title: 'Warning'
            }).then(res => {
                if (res === true) {
                    this.isRecreatingReportingCache = true
					this.$store.dispatch('recreateReportingCache')
						.then(res => {
							this.isRecreatingReportingCache = false
							this.isReportingCacheRecreated = true
							this.reportingCacheItems = res
						})
                }
            })
		},
		recreateOrderCache () {
			this.$confirm(`Do you really want to recreate the Order cache?`, {
                color: 'warning',
                icon: 'warning',
                title: 'Warning'
            }).then(res => {
                if (res === true) {
                    this.isRecreatingOrderCache = true
					this.$store.dispatch('recreateOrderCache')
						.then(res => {
							this.isRecreatingOrderCache = false
							this.ohCacheItems = res
							this.isOhRecreated = true
						})
                }
            })
			
		}
    }
}
</script>
